import { adminHttpClient } from '../commons/adminHttpClient'
import { submitToServerFormat } from '../commons/dateFormatters'

export enum IsPurchaseDateValidForEmployeeResponse {
  Correct,
  BeforePlanPeriodStarted,
  After90DaysPlanPeriodEndDate,
  BeforeBenefitEligibilityDate,
  After90DaysTerminationDate,
  NoAvailablePlanPeriod
}

const isPurchaseDateValidForEmployee = (
  planPeriodId: string,
  companyUserId: string,
  purchasedDate: string,
): Promise<IsPurchaseDateValidForEmployeeResponse> => {
  return adminHttpClient.get(`/Expenses/IsPurchaseDateValidForEmployee`, {
    planPeriodId,
    companyUserId,
    purchasedDate: submitToServerFormat(purchasedDate),
  })
}

export default isPurchaseDateValidForEmployee
